import { html } from "lit";
var icon_barchart_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g fill-rule="evenodd">
      <g transform="translate(2.5 4)">
        <path
          d="M16.653 3.857c0 1.42-1.069 2.572-2.388 2.572H7.898c-1.319 0-2.388-1.152-2.388-2.572V3C5.51 1.58 6.58.429 7.898.429h6.367c1.319 0 2.388 1.15 2.388 2.571v.857zM22.224 21c0 1.42-1.069 2.571-2.387 2.571H7.898c-1.319 0-2.388-1.15-2.388-2.571v-.857c0-1.42 1.07-2.572 2.388-2.572h11.939c1.318 0 2.387 1.152 2.387 2.572V21zm3.98-8.571c0 1.42-1.069 2.571-2.388 2.571H7.898c-1.319 0-2.388-1.151-2.388-2.571v-.858C5.51 10.151 6.58 9 7.898 9h15.918c1.319 0 2.388 1.151 2.388 2.571v.858zM15.061 3.857V3c0-.473-.356-.857-.796-.857H7.898c-.44 0-.796.384-.796.857v.857c0 .474.356.857.796.857h6.367c.44 0 .796-.383.796-.857zM20.633 21v-.857c0-.474-.357-.857-.796-.857H7.898c-.44 0-.796.383-.796.857V21c0 .473.356.857.796.857h11.939c.44 0 .796-.384.796-.857zm3.98-8.571v-.858c0-.473-.357-.857-.797-.857H7.898c-.44 0-.796.384-.796.857v.858c0 .473.356.857.796.857h15.918c.44 0 .796-.384.796-.857z"
          fill-rule="nonzero" />
        <rect y=".857" width="1.714" height="23.143" rx=".857" />
      </g>
    </g>
  </svg>
`;
export {
  icon_barchart_default as default
};
//# sourceMappingURL=icon-barchart.js.map
